module.exports = __webpack_public_path__ + "static/media/1.a8098bc5.jpg";